import {
  defectListDrawerResizePlugin,
  readDefectListDrawerWidth,
  DEFECT_LIST_DRAWER_DEFAULT_WIDTH
} from '@/ui/plugins/defectListDrawerResizePlugin.js';

/**
 * DefectListDrawer width 리사이즈 + IndexedDB 복원
 *
 * template:
 *   ref="defectListDrawer"
 *   :width="defectListDrawerWidth"
 *
 * data: drawerOpen (또는 watch 대상 prop 이름을 drawerOpenWatcher로 오버라이드)
 */
export const defectListDrawerResizeMixin = {
  data() {
    return {
      defectListDrawerWidth: DEFECT_LIST_DRAWER_DEFAULT_WIDTH
    };
  },

  watch: {
    drawerOpen(isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          this.initDefectListDrawerResize();
        });
      }
    }
  },

  mounted() {
    if (this.drawerOpen) {
      this.$nextTick(() => {
        this.initDefectListDrawerResize();
      });
    }
  },

  methods: {
    async initDefectListDrawerResize() {
      const ref = this.$refs.defectListDrawer;
      const el = ref?.$el ?? ref;
      if (!el) {
        return;
      }
      this.defectListDrawerWidth = await readDefectListDrawerWidth();
      this.teardownDefectListDrawerResize();
      this._defectListDrawerResizeCleanup = defectListDrawerResizePlugin.attach(el, {
        getWidth: () => this.defectListDrawerWidth,
        setWidth: width => {
          this.defectListDrawerWidth = width;
        },
        onResize: () => {
          window.dispatchEvent(new Event('resize'));
        }
      });
    },

    teardownDefectListDrawerResize() {
      if (typeof this._defectListDrawerResizeCleanup === 'function') {
        this._defectListDrawerResizeCleanup();
        this._defectListDrawerResizeCleanup = null;
      }
    }
  },

  beforeDestroy() {
    this.teardownDefectListDrawerResize();
  }
};
